import React, {ReactNode} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadNewPackageSelfCareBlockData from '../../../Models/Content/AbroadNewPackageSelfCareBlockData';
import AbroadNewPackageSelfCareBlock from './AbroadNewPackageSelfCare';

export default class PopupBenefitBlock extends EpiComponent<AbroadNewPackageSelfCareBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | null {
    return <AbroadNewPackageSelfCareBlock context={this.getContext()} iContent={this.props.data} />;
  }
}
